module.exports = __webpack_public_path__ + "img/stripe.141ca681.svg";